"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var __1 = require("..");
var react_1 = require("@emotion/react");
var defaultProps = {
    checked: false,
    disabled: false,
    alignCheckbox: 'center',
};
var getCSSRules = function (_a, props) {
    var colors = _a.colors;
    return ({
        wrapper: {
            display: 'inline-flex',
            alignItems: props.alignCheckbox === 'center' ? 'center' : 'flex-start',
            cursor: props.disabled ? 'default' : 'pointer',
        },
        checkbox: {
            cursor: props.disabled ? 'default' : 'pointer',
            boxSizing: 'border-box',
            borderRadius: 3,
            display: 'inline-block',
            flexShrink: 0,
            width: 16,
            height: 16,
            textAlign: 'center',
            border: "1px solid ".concat(colors.Grey[props.disabled ? 400 : 500]),
            '&:hover': {
                borderColor: colors.Grey[props.disabled ? 400 : 600],
            },
        },
        active: {
            backgroundColor: !props.disabled ? colors.Hannibal[600] : undefined,
        },
        input: {
            display: 'none',
        },
        check: __assign({ marginBottom: 5 }, (props.checked && {
            stroke: props.disabled ? colors.Grey[400] : colors.Grey[0],
        })),
        label: {
            marginLeft: 8,
        },
    });
};
var Check = function (props) {
    var checked = props.checked;
    var theme = (0, react_1.useTheme)();
    var styles = getCSSRules(theme, props);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: checked && ((0, jsx_runtime_1.jsx)("svg", __assign({ css: styles.check, width: "10", height: "8", viewBox: "0 0 10 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M1 4L4 7L9 1", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, void 0) }), void 0)) }, void 0));
};
var Checkbox = function (props) {
    var checked = props.checked, label = props.label, style = props.style, className = props.className, alignCheckbox = props.alignCheckbox, rest = __rest(props, ["checked", "label", "style", "className", "alignCheckbox"]);
    var theme = (0, react_1.useTheme)();
    var styles = getCSSRules(theme, props);
    return ((0, jsx_runtime_1.jsx)(react_1.ClassNames, { children: function (_a) {
            var _b;
            var cx = _a.cx, css = _a.css;
            return ((0, jsx_runtime_1.jsxs)("label", __assign({ className: cx(css(styles.wrapper), className), style: style }, { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: cx(css(styles.checkbox), (_b = {},
                            _b[css(styles.active)] = checked,
                            _b)) }, { children: [(0, jsx_runtime_1.jsx)("input", __assign({ type: "checkbox", checked: checked, css: styles.input }, rest), void 0), (0, jsx_runtime_1.jsx)(Check, __assign({ checked: checked, alignCheckbox: alignCheckbox }, rest), void 0)] }), void 0), label &&
                        (typeof label === 'string' ? ((0, jsx_runtime_1.jsx)(__1.Typography, __assign({ variant: 'textMedium', css: styles.label, color: props.disabled ? 'Grey@400' : 'Grey@900' }, { children: label }), void 0)) : (label))] }), void 0));
        } }, void 0));
};
Checkbox.defaultProps = defaultProps;
exports.default = Checkbox;
//# sourceMappingURL=index.js.map